import Vue from 'vue';
import Vuex from 'vuex';
import {find, isNil} from "lodash";
import ApiService from "@/service/ApiService";

Vue.use(Vuex);

//export const serviceUrl = "http://localhost:8081"; //USER_SERVICE_URL
export const serviceUrl = "https://heroku-adminservice.herokuapp.com";

const BlogStore = {
    state: {
        blogList: [
            {
                id: '1',
                shown: false,
                title: 'title 1 lkajf  dajf kaj kajsf kajf lka',
                imgSrc: "https://webcapsule.de/img/gopro2.jpg",
                imgSrcLowRes: "https://webcapsule.de/img/gopro2_lowres.jpg",
                imgAlt: 'image 1',
                author: 'Martin Loos',
                date: '16.06.2020',
                teaserText: 'This is the ultimative teaser text. jksaljf lkajfkas jflka jflka jfkaj fka jfakjf ak ' +
                    'ja fkja ka ja fdkjfdakj jdsfajf lka jak jfakjfksajkfj ak j akfj kj k jfakjf akj fakj' +
                    'a sfkja sjfka j k dajk jkfals jk j safkj lkasjfkjfdskaj flak j',
                contentDTOS: [{
                    contentId: 1,
                    blogText: 'this is blog 1 ajsk faks faksf akfj kdsjf aksjfkasjf aksjf aksdfj aksdjf kasjfd ksadj fksdjf a' +
                        ' ksa djflksa jfks jfkasjfkaj fakjf akjfkajfkdjfak f' +
                        'k sfj aksfjkal jfkajdfkasjfkjdsfksjdfakjf f d fkds jfdsk jfkd jfakjf kjf k f',
                    headLine: 'this is the headline',
                    contentImage: 'https://webcapsule.de/img/insta_4.jpg',
                    contentImageLowRes: "https://webcapsule.de/img/insta_4_lowres.jpg",
                },
                    {
                        contentId: 2,
                        blogText: 'kjf akdsjf kajf kdsjf kasjf kajf akjf akjf akj fkaj fkaj fkaj klasdj fkasj fkja f' +
                            'd kfajfd kajfda kljfa lkjlkda jka d' +
                            ' dkajkds jfalksd jfka a',
                        headLine: 'this is the headline2',
                        contentImage: 'https://webcapsule.de/img/gopro1.jpg',
                        contentImageLowRes: "https://webcapsule.de/img/gopro1_lowres.jpg",
                    }
                ],
            },
            {
                id: '2',
                shown: false,
                title: 'title 2',
                imgSrc: 'https://webcapsule.de/img/insta_3.jpg',
                imgSrcLowRes: "https://webcapsule.de/img/insta_3_lowres.jpg",
                imgAlt: 'image 2',
                author: 'Martin Loos',
                date: '16.06.2020',
                teaserText: 'This is the ultimative teaser text.',
                contentDTOS: [{}]
            },
            {
                id: '3',
                shown: false,
                title: 'title 3',
                imgSrc: "https://webcapsule.de/img/gopro3.jpg",
                imgSrcLowRes: "https://webcapsule.de/img/gopro3_lowres.jpg",
                imgAlt: 'image 3',
                author: 'Martin Loos',
                date: '16.06.2020',
                teaserText: 'This is the ultimative teaser text.',
                contentDTOS: [{
                    id: 1,
                    blogText: 'this is blog 1 ajsk faks faksf akfj kdsjf aksjfkasjf aksjf aksdfj aksdjf kasjfd ksadj fksdjf a' +
                        ' ksa djflksa jfks jfkasjfkaj fakjf akjfkajfkdjfak f' +
                        'k sfj aksfjkal jfkajdfkasjfkjdsfksjdfakjf f d fkds jfdsk jfkd jfakjf kjf k f',
                    headLine: 'this is the headline',
                    contentImage: "https://webcapsule.de/img/insta_5.jpg",
                    contentImageLowRes: "https://webcapsule.de/img/insta_5_lowres.jpg",
                },
                    {
                        id: 2,
                        blogText: 'kjf akdsjf kajf kdsjf kasjf kajf akjf akjf akj fkaj fkaj fkaj klasdj fkasj fkja f' +
                            'd kfajfd kajfda kljfa lkjlkda jka d' +
                            ' dkajkds jfalksd jfka a',
                        headLine: 'this is the headline2',
                        contentImage: "https://webcapsule.de/img/insta_2.jpg",
                        contentImageLowRes: "https://webcapsule.de/img/insta_2_lowres.jpg"
                    }
                ],
            },
        ]
    },
    getters: {
        blog: state => state.blog,
        allBlogs: state => state.blogList
    },
    mutations: {
        updateBlogList(state, blogList) {
            state.blogList = blogList;
        },
    },
    actions: {
        getBlogById({ state }, givenId) {
            if (!isNil(givenId)) {
                return find(state.blogList, blog => blog.id === givenId);
            }
            return null;
        },
        getAllBlogs() {
            return this.store.blogList;
        },
        async fetchBlogList({ commit }) {
            const blogList = await ApiService.doGet(`${serviceUrl}/blogs/all`);
            if (!isNil(blogList)) {

                commit('updateBlogList', blogList);
                return true;
            }
            return false;
        },
        async uploadBlog({ getters }, { title, fileName, lowRes, teaserText, content }) {
            console.log(title);
            console.log(fileName);
            console.log(teaserText);
            console.log('content: ' + content);
            if (getters.isAuthenticated) {
                if (!isNil(title) && !isNil(fileName) && !isNil(lowRes) && !isNil(teaserText)
                && !isNil(content)) {
                    console.log('posted to /uploadBlog');
                    const response = await ApiService.doPost(`${serviceUrl}/blogs/uploadBlog`,
                        { title: title, imgSrc: fileName, imgSrcLowRes: lowRes, teaserText: teaserText,
                        content: content});

                    if (!isNil(response)) {
                        return response;
                    }
                }
            }
            return null;
        },
    }
};

export default BlogStore;
